<template>
<div class="d-flex flex-row bd-highlight mb-3 align-items-center ">
  <div class="p-2 bd-highlight ml-5">
      <div class="d-flex flex-column bd-highlight">
  <div class="p-2 bd-highlight laugh">
      <img src="../../assets/img/laugh.png">
  </div>
  <div class="p-2 bd-highlight">
      <p class="ml-4 jerin">Jerin Khan</p>
  </div>
  <div class="p-2 bd-highlight">
      <p class="ml-4 jerin">21 Feb, 2017</p>
  </div>
</div>
  </div>
  <div class="p-2 bd-highlight col mt-5">
      <div class="d-flex flex-column bd-highlight three mb-3">
  <div class="p-2 bd-highlight ">
      <h2 class="w-50 ">Three simple way to save a money lorium ipsum</h2>
  </div>
  <div class="p-2 bd-highlight">
      <p class="w-50">A wonderful serenity has taken possession of my entire soul, like these sweet mornings of spring which I enjoy with my whole heart. I am alone, and feel the.A wonderful serenity has taken possession of my entire soul, like these sweet mornings of spring which I enjoy with my whole heart. I am alone, and feel the.A wonderful serenity has taken possession of my entire soul, like these sweet mornings of spring which I enjoy with my whole heart.</p>
  </div>
  <div class="p-2 bd-highlight">
      <p class="w-50">I am alone, and feel the.A wonderful serenity has taken possession of my entire soul, like these sweet mornings of spring which I enjoy with my whole heart. I am alone, and feel the.A wonderful serenity has taken possession of my entire soul, like these sweet mornings of spring which I enjoy with my whole heart.</p>
  </div>
</div>
  </div>
</div>
</template>

<script>



export default {
  
    data () {
    return {
      
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/page5/advice.vue